import { useState } from "react";

const ALL_MEMBERS = [
  {
    name: "Gary Cameron",
    role: "Chief Energy Officer",
    emoji: "\u26A1",
    img: "https://cdn.candopayments.com/team/gary-cameron_colour_web_solid.webp",
    bio: "Having worked as a chef and owned his own business, Gary understands the priorities and challenges faced by business owners first-hand. He brings keen business acumen and a genuine passion for helping businesses succeed.",
    funFact: "Passionate about Pilates and somehow still finds energy after powering through the day.",
    askMeAbout: "Why your payment provider is probably overcharging you",
    motto: "If it doesn't feel right, it probably isn't.",
    joined: "Founder, 2018",
    isFounder: true,
  },
  {
    name: "Samantha Cameron",
    role: "Chief Revenue Officer",
    emoji: "\uD83D\uDCB0",
    img: "https://cdn.candopayments.com/team/sam-cameron_colour_web_solid.webp",
    bio: "With a background in NHS Occupational Therapy and front-of-house operations, Sam understands care, communication, and building teams. She left the NHS to join CanDo and transformed how the company runs.",
    funFact: "Gym enthusiast, music lover, and busy mum of three. Juggles it all with ease.",
    askMeAbout: "Building a team that actually cares",
    motto: "Work hard, be kind, and never settle.",
    joined: "Co-Founder, 2021",
    isFounder: true,
  },
  {
    name: "Becky Burns",
    role: "Head of Operations & Delivery",
    emoji: "\u2699\uFE0F",
    img: "https://cdn.candopayments.com/team/becky-burns_colour_web_solid.jpg",
    bio: "With over 16 years in customer service and operations, Becky brings a people-focused, solutions-driven approach. 10 years in operations and 6 years in a GP surgery gave her a deep understanding of care and communication.",
    funFact: "Makes incredible gluten-free and dairy-free brownies — you'd never know what they were missing!",
    askMeAbout: "How we get your terminal live in 24 hours",
    motto: "Every detail matters.",
    joined: "2023",
    isFounder: false,
  },
  {
    name: "Ben Maudslay",
    role: "Lead Systems Architect / CTO",
    emoji: "\uD83D\uDCBB",
    img: "https://cdn.candopayments.com/team/ben-maudslay_colour_web_solid.jpg",
    bio: "Ben is the technical backbone of CanDo Payments — designing and maintaining the systems that power our integrations, tools, and client infrastructure.",
    funFact: "Details coming soon — watch this space!",
    askMeAbout: "How the tech behind your payments actually works",
    motto: "Build it right, or build it twice.",
    joined: "2024",
    isFounder: false,
  },
  {
    name: "Vidi Wagh",
    role: "Partner Growth Executive",
    emoji: "\uD83D\uDE80",
    img: "https://cdn.candopayments.com/team/vidi-wagh_colour_web_solid.jpg",
    bio: "Vidi works with our partner network to grow referral volumes and ensure partners have everything they need to succeed.",
    funFact: "Details coming soon — watch this space!",
    askMeAbout: "Getting started as a CanDo partner",
    motto: "Growth is a team sport.",
    joined: "2024",
    isFounder: false,
  },
  {
    name: "Connor Rooney",
    role: "Partner Growth Executive",
    emoji: "\uD83D\uDE80",
    img: null,
    bio: "Connor supports our partner programme, building relationships and helping partners unlock recurring commission through CanDo.",
    funFact: "Details coming soon — watch this space!",
    askMeAbout: "How the partner programme actually works day-to-day",
    motto: "Relationships first, results follow.",
    joined: "2024",
    isFounder: false,
  },
  {
    name: "Bailey",
    role: "Chief Biscuit Officer",
    emoji: "\uD83D\uDC36",
    img: "https://cdn.candopayments.com/team/bailey_colour_web_solid.jpg",
    bio: "The real boss. Gary and Sam may have founded CanDo, and they may have three kids — but make no mistake, Bailey runs the show.",
    funFact: "Holds the office record for longest nap (4 hours 12 minutes). Also once stole Simon's lunch.",
    askMeAbout: "When the next snack break is",
    motto: "Sleep. Eat. Supervise. Repeat.",
    joined: "Since day one",
    isFounder: false,
  },
];

function FlipCard({ member }) {
  const [flipped, setFlipped] = useState(false);
  const [burst, setBurst] = useState(false);
  const initials = member.name.split(" ").map((n) => n[0]).join("");

  const handleFlip = () => {
    setBurst(true);
    setFlipped((f) => !f);
    setTimeout(() => setBurst(false), 800);
  };

  return (
    <div
      className="group cursor-pointer relative"
      style={{ perspective: "1000px" }}
      onClick={handleFlip}
      data-testid={`flip-card-${member.name.toLowerCase().replace(/\s+/g, '-')}`}
    >
      {/* Emoji burst overlay */}
      {burst && (
        <div className="absolute inset-0 z-20 pointer-events-none flex items-center justify-center">
          <span className="emoji-burst text-8xl">{member.emoji}</span>
        </div>
      )}

      <div
        className="relative w-full aspect-[3/5] transition-transform duration-700 ease-out"
        style={{
          transformStyle: "preserve-3d",
          transform: flipped ? "rotateY(180deg)" : "rotateY(0deg)",
        }}
      >
        {/* FRONT */}
        <div className="w-full" style={{ backfaceVisibility: "hidden" }}>
          <div className="bg-white border border-brand-light-grey rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-shadow">
            <div className="relative flex-1">
              {member.img ? (
                <img src={member.img} alt={member.name} className="w-full aspect-[3/4] object-cover" style={member.imgPosition ? { objectPosition: member.imgPosition } : undefined} />
              ) : (
                <div className="w-full aspect-[3/4] bg-gradient-to-br from-brand-aqua-light via-white to-gray-100 flex items-center justify-center">
                  <span className="text-5xl font-heading font-bold text-brand-aqua/40">{initials}</span>
                </div>
              )}
              {/* Emoji badge */}
              <div className="absolute top-3 right-3 w-10 h-10 rounded-full bg-white/90 backdrop-blur-sm border border-brand-light-grey/60 flex items-center justify-center text-xl shadow-sm">
                {member.emoji}
              </div>
              {/* Founder badge */}
              {member.isFounder && (
                <div className="absolute top-3 left-3 bg-brand-aqua text-white text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full">Founder</div>
              )}
            </div>
            <div className="p-4">
              <h3 className="font-heading font-bold text-brand-black text-lg leading-tight">{member.name}</h3>
              <p className="text-xs text-brand-aqua font-semibold mt-0.5">{`${member.emoji} ${member.role}`}</p>
              <p className="text-[10px] text-brand-grey mt-2 uppercase tracking-wider">Tap to learn more</p>
            </div>
          </div>
        </div>

        {/* BACK */}
        <div
          className="absolute inset-0 w-full"
          style={{ backfaceVisibility: "hidden", transform: "rotateY(180deg)" }}
        >
          <div className="bg-brand-black text-white rounded-2xl overflow-hidden shadow-xl h-full flex flex-col">
            {/* Header */}
            <div className="bg-gradient-to-r from-brand-aqua-dark to-brand-aqua px-5 py-4">
              <div className="flex items-center gap-3">
                <span className="text-2xl">{member.emoji}</span>
                <div>
                  <h3 className="font-heading font-bold text-white text-lg leading-tight">{member.name}</h3>
                  <p className="text-brand-aqua-light text-xs font-semibold">{member.role}</p>
                </div>
              </div>
            </div>

            {/* Content */}
            <div className="flex-1 px-5 py-4 space-y-3 overflow-y-auto">
              <div>
                <p className="text-[10px] uppercase tracking-wider text-brand-grey mb-1">Bio</p>
                <p className="text-xs text-white/80 leading-relaxed">{member.bio}</p>
              </div>

              <div className="border-t border-white/10 pt-3">
                <p className="text-[10px] uppercase tracking-wider text-brand-grey mb-1">Fun Fact</p>
                <p className="text-xs text-white/80 leading-relaxed">{member.funFact}</p>
              </div>

              <div className="border-t border-white/10 pt-3">
                <p className="text-[10px] uppercase tracking-wider text-brand-grey mb-1">Ask Me About</p>
                <p className="text-xs text-brand-aqua font-semibold">{member.askMeAbout}</p>
              </div>

              <div className="border-t border-white/10 pt-3">
                <p className="text-[10px] uppercase tracking-wider text-brand-grey mb-1">Motto</p>
                <p className="text-xs text-white/80 italic">{`“${member.motto}”`}</p>
              </div>
            </div>

            {/* Footer */}
            <div className="px-5 py-3 border-t border-white/10 flex items-center justify-between">
              <span className="text-[10px] text-brand-grey">{`Joined: ${member.joined}`}</span>
              <span className="text-[10px] text-brand-grey uppercase tracking-wider">Tap to flip back</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export { ALL_MEMBERS };
export default FlipCard;
